import React from 'react'

import { BorderLoader } from '@/components/ui/loaders/border-loader'
import { routerFactory } from '@/factories'

import * as S from './link.styled'
import type { LinkProps } from './link.types'

export const Link = ({
  children,
  to,
  navigateBack = false,
  use = 'primary',
  size = 'medium',
  disabled = false,
  loading = false,
  onlyBox = false,
  onlyCircle = false,
  onClick,
  ...rest
}: LinkProps) => {
  const { navigateBack: routerNavigateBack } = routerFactory.useRouter()
  const overrideDisabled = loading
  const isDisabled = disabled || overrideDisabled

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (isDisabled) {
      e.preventDefault()
      return
    }

    if (navigateBack) {
      e.preventDefault()
      routerNavigateBack(to)
      return
    }

    onClick?.(e)
  }

  const href = routerFactory.getPathString(to)

  return (
    <S.Link
      {...rest}
      to={href}
      $use={use}
      $size={size}
      $onlyBox={onlyBox}
      $onlyCircle={onlyCircle}
      $overrideDisabled={overrideDisabled}
      aria-disabled={isDisabled}
      data-component-id="Link"
      onClick={handleClick}
    >
      {/* NOTE: Link is mostly a complete replica of a `Button` but as a separate component for better TS coverage */}
      <S.ChildrenWrapper data-button-children-wrapper>{children}</S.ChildrenWrapper>
      {loading && <BorderLoader data-button-loader align="absolute-center" size={size} />}
    </S.Link>
  )
}
